import FilterType from './filterType';
import valueIn from '../../utils/valueIn';

export default FilterType({
    id: 'GUEST_RATING',
    filterFunction: (allHotelIds, filterTree, currentFilterValues, segmentationState, filterId, hotels) => {
        let isFilterActive = false;
        const isHotelInRatingRange = {};

        const minGuestRating = valueIn(currentFilterValues, 'minGuestRating');
        const maxGuestRating = valueIn(currentFilterValues, 'maxGuestRating');
        const selectedLowValue = valueIn(currentFilterValues, 'selectedGuestRatings.value.lowValue') || 0;
        const selectedHighValue = valueIn(currentFilterValues, 'selectedGuestRatings.value.highValue') || 5;

        if((selectedLowValue && selectedLowValue > minGuestRating) || (selectedHighValue && selectedHighValue < maxGuestRating)) {
            isFilterActive = true;

            const bucket = valueIn(filterTree, [filterId, 'hasGuestRating']) || [];
            bucket.forEach(hotelId => {
                const hotelData = valueIn(hotels, [`${hotelId}`]);

                const guestRating = valueIn(hotelData, 'guestRating');

                isHotelInRatingRange[hotelId] = guestRating >= selectedLowValue  && guestRating <= selectedHighValue;
            });
        }

        if (!isFilterActive) {
            return 0;
        }

        const ratingPotentials = [];

        allHotelIds.forEach(hotelId => {
            if (!segmentationState.block[hotelId]) {
                ratingPotentials.push(hotelId);
            }

            if (isHotelInRatingRange[hotelId]) {
                segmentationState.match[hotelId] = !segmentationState.block[hotelId];
            } else {
                segmentationState.match[hotelId] = false;
                segmentationState.block[hotelId] = true;

                Object.keys(segmentationState.potentials).forEach(potentialsFilterId => {
                    if (segmentationState.potentials[potentialsFilterId][hotelId]) {
                        segmentationState.potentials[potentialsFilterId][hotelId] = false;
                    }
                });
            }
        });

        segmentationState.potentials[filterId] = {};
        ratingPotentials.forEach(hotelId => {
            segmentationState.potentials[filterId][hotelId] = true;
        });


        return isFilterActive ? 1 : 0;
    },
});